import { render, staticRenderFns } from "./receiptDocumentDescriptionsList.vue?vue&type=template&id=4e9766a8&scoped=true&"
import script from "./receiptDocumentDescriptionsList.vue?vue&type=script&lang=js&"
export * from "./receiptDocumentDescriptionsList.vue?vue&type=script&lang=js&"
import style0 from "./receiptDocumentDescriptionsList.vue?vue&type=style&index=0&id=4e9766a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9766a8",
  null
  
)

export default component.exports